import React, { useState } from "react";

import { Link } from "react-router-dom";

import "./index.css";

function Header() {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div
      className="w-100 border-bottom-style bg-light"
      style={{ position: "fixed", zIndex: "99", top: "0px" }}
    >
      <nav className="navbar navbar-expand-lg container">
        <div className="container-fluid">
          <button
            className="navbar-toggler text-light"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
              <li className="nav-item">
                <a className="nav-link p-0" href="http://jpp.org.pk/">
                  <h1 className="m-0">
                    <img
                      src={require("../assets/images/logo/jpp-logo.png")}
                      height={"40px"}
                      alt="JPP-Logo"
                    />
                  </h1>
                </a>
              </li>
              <li
                className={
                  activeTab === "home" ? "nav-tab nav-item" : "nav-item"
                }
              >
                <Link
                  className="nav-link"
                  to="/"
                  onClick={() => {
                    setActiveTab("home");
                    document
                      .getElementById("navbarSupportedContent")
                      .classList.remove("show");
                  }}
                >
                  HOME
                </Link>
              </li>
              <li
                className={
                  activeTab === "punjab" ? "nav-tab nav-item" : "nav-item"
                }
              >
                <Link
                  className="nav-link"
                  to="/punjab"
                  onClick={() => {
                    setActiveTab("punjab");
                    document
                      .getElementById("navbarSupportedContent")
                      .classList.remove("show");
                  }}
                >
                  PUNJAB
                </Link>
              </li>
              <li
                className={
                  activeTab === "sindh" ? "nav-tab nav-item" : "nav-item"
                }
              >
                <Link
                  className="nav-link"
                  to="/sindh"
                  onClick={() => {
                    setActiveTab("sindh");
                    document
                      .getElementById("navbarSupportedContent")
                      .classList.remove("show");
                  }}
                >
                  SINDH
                </Link>
              </li>
              <li
                className={
                  activeTab === "kp/fata" ? "nav-tab nav-item" : "nav-item"
                }
              >
                <Link
                  className="nav-link"
                  to="/kpk"
                  onClick={() => {
                    setActiveTab("kp/fata");
                    document
                      .getElementById("navbarSupportedContent")
                      .classList.remove("show");
                  }}
                >
                  KP/FATA
                </Link>
              </li>
              <li
                className={
                  activeTab === "balochistan" ? "nav-tab nav-item" : "nav-item"
                }
              >
                <Link
                  className="nav-link"
                  to="/balochistan"
                  onClick={() => {
                    setActiveTab("balochistan");
                    document
                      .getElementById("navbarSupportedContent")
                      .classList.remove("show");
                  }}
                >
                  BALOCHISTAN
                </Link>
              </li>
              <li
                className={
                  activeTab === "women" ? "nav-tab nav-item" : "nav-item"
                }
              >
                <Link
                  className="nav-link"
                  to="/women"
                  onClick={() => {
                    setActiveTab("women");
                    document
                      .getElementById("navbarSupportedContent")
                      .classList.remove("show");
                  }}
                >
                  WOMEN
                </Link>
              </li>
            </ul>
            <div>
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    aria-current="page"
                    href="#"
                    onClick={() => {
                      document
                        .getElementById("navbarSupportedContent")
                        .classList.remove("show");
                    }}
                  >
                    SHARE
                  </a>
                </li>
                <li className="nav-item">
                  <button
                    className="btn btn-black"
                    onClick={() => {
                      document
                        .getElementById("navbarSupportedContent")
                        .classList.remove("show");
                    }}
                  >
                    DOWNLOAD FULL BOOK
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
